import { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { ASK_PSD_API_BASE_URL } from '@config/envConfig';

const WIDGET_PROJECT_ID = 'PSD';
const WIDGET_HOST = '';

export default function ChatWidgetMount() {
  const { oktaAuth } = useOktaAuth();
  // FilterProvider (mounted elsewhere in the tree) broadcasts the current
  // global filter selections here so this component can pick them up
  // without needing to sit inside FilterProvider's own subtree.
  const [metadataFilters, setMetadataFilters] = useState(
    () => window.__psdGlobalFilters__ || {}
  );
  const [filterLabels, setFilterLabels] = useState(
    () => window.__psdGlobalFilterLabels__ || []
  );

  useEffect(() => {
    const onFiltersChanged = () => {
      setMetadataFilters({ ...(window.__psdGlobalFilters__ || {}) });
      setFilterLabels([...(window.__psdGlobalFilterLabels__ || [])]);
    };
    window.addEventListener('psd-global-filters-changed', onFiltersChanged);
    return () =>
      window.removeEventListener('psd-global-filters-changed', onFiltersChanged);
  }, []);

  useEffect(() => {
    const config = {
      apiBaseUrl: ASK_PSD_API_BASE_URL,
      projectId: WIDGET_PROJECT_ID,
      metadataFilters,
      filterLabels,
      authToken: oktaAuth?.getAccessToken(),
    };

    if (window.PsdChatWidget) {
      window.PsdChatWidget.mount(config);
      return undefined;
    }

    if (document.querySelector('script[data-psd-chat-widget]')) return undefined;

    const script = document.createElement('script');
    script.src = `${WIDGET_HOST}/widget.js`;
    script.dataset.psdChatWidget = 'true';
    script.onload = () => window.PsdChatWidget.mount(config);
    document.body.appendChild(script);

    return undefined;
  }, [oktaAuth, metadataFilters, filterLabels]);

  return null;
}
